import {EventEmitter, Injectable} from '@angular/core';
import {Theme} from '../types/admin-data.types';

declare const $;

@Injectable()
export class CustomStyleService {
    onThemeChanged: EventEmitter<any> = new EventEmitter();
    private defaultLogo = '/assets/img/logo-maxtv-login.png';
    obj = {
        id: null,
        colors: {
            body: '#f3f3f4',
            primary: '#1ab394',
            primaryHover: '#1a7794',
            secondary: '#1a7794',
            menuBackgroundColor: '#ffffff',
            menuFontColor: '#767677',
            selectedMenuItemFontColor: '#767677',
        },
        logo: this.defaultLogo,
        miniLogo: ''
    };

    constructor() {
        const cs = localStorage.getItem('mtvCustomStyle');
        if (cs) {
            const csObj = JSON.parse(cs);
            this.obj.id = csObj.id;
            this.obj.colors = csObj.colors;
            this.obj.logo = csObj.logo;
            this.obj.miniLogo = csObj.miniLogo ? csObj.miniLogo : csObj.logo;
            this.updateStyle();
        }
    }

    updateStyle() {
        $('#mtvCustomStyle').remove();
        $(`
            <style id="mtvCustomStyle">
                /* personalized color variables */
                :root {
                    --mtv-primary-color: ${this.obj.colors.primary};
                    --mtv-primary-hover-color: ${this.obj.colors.primary};
                 }

                /* background-color body  */
                .mtv-body-color {
                    background-color: ${this.obj.colors.body} !important;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }

                /* background-color primary  */
                .mtv-primary-bg-color,
                .mtv-primary-bg-color-no-hover,
                .btn-primary,
                .sk-spinner-wave div,
                .ss_dropdown li.focus,
                .pure-checkbox input[type="checkbox"]:checked + label:before,
                .parcel-modal .parcel-type-switch input:checked + label,
                .radio-tabs input:checked + label,
                .parcel-transit-modal .input-radio label:after,
                .datepicker table tr td span.active,
                .datepicker table tr td.active.day,
                .pace .pace-progress,
                .mat-calendar-body-selected,
                .module-notices .btn.active,
                ._steps-items li.passed, ._steps-items li.passed:before,
                .checkbox span:after,
                .switch.active .switch__control,
                .checkbox span:after,
                .step-progress-bar div,
                .amenity-progress > div.mtv-primary-color:after,
                .settings-amenities-slider-container .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,
                .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-inner-circle,
                .custom-repeat-window .mat-mini-fab.mat-accent.active,
                .mat-option.mat-active, .mat-option:hover,
                .mat-checked .mat-slide-toggle-bar,
                .mat-progress-bar-fill::after,
                .amenity-image-svg,
                .schedule-header
                {
                    background-color: ${this.obj.colors.primary} !important;
                }

                /* background gradient primary  */
                .mtv-primary-bg-gradient {
                    background-color: ${this.obj.colors.primary} !important;
                    background: linear-gradient(90deg, #efa85b 0%, ${this.obj.colors.primary} 100%);
                }

                /* hover background-color primary  */
                .mtv-primary-bg-color:hover,
                .btn-primary:hover,
                .selected-item,
                .multiselect-item-checkbox input[type=checkbox]:checked + div:before,
                .preview-icon:hover, .set-icon:hover,
                .mat-checkbox-checked.mat-accent .mat-checkbox-background,
                .mat-form-field-ripple
                {
                    background-color: ${this.obj.colors.primaryHover} !important;
                }

                /* color primary  */
                .mtv-primary-color,
                .timeline__active,
                .item-nav__link.item-nav__link_active,
                .btn-default-green,
                .detailed-view-body .btn-default,
                .btn-in-table .btn,
                .btn-outline-primary,
                .parcel-modal .parcel-type-switch input:not(:checked) + label,
                .radio-tabs input:not(:checked) + label,
                .documents-list-table__directory,
                .path > li > a,
                .directory-icon,
                .module-notices .btn-add,
                .module-notices .display-orientation .btn:not(.active),
                .advance-schedule-tuner a,
                .module-notices ._item:hover,
                .list-unstyled.status .droupdown a,
                .preview-icon, .set-icon,
                .item ._tags a,
                .settings-side-menu li.active a,
                .customLable,
                .mat-focused .mat-form-field-label,
                .mat-focused .mat-select-arrow,
                .building-setup-wrapper .sidenav li.active
                {
                    color: ${this.obj.colors.primary} !important;
                }

                /* hover color primary  */
                .mtv-primary-color:hover,
                .btn-default-green:hover,
                .detailed-view-body .btn-default:hover,
                .btn-in-table .btn:hover,
                .parcel-modal .parcel-type-switch input:not(:checked) + label:hover,
                .radio-tabs input:not(:checked) + label:hover,
                ._item:hover ._icon
                {
                    color: ${this.obj.colors.primaryHover} !important;
                }

                /* border-color primary  */
                .mtv-primary-border,
                .btn-primary,
                .btn-outline-primary,
                .selected-item,
                .btn-default-green,
                .detailed-view-body .btn-default,
                .btn-in-table .btn,
                .parcel-modal .parcel-type-switch,
                .radio-tabs,
                .pure-checkbox input[type="checkbox"] + label:before,
                .parcel-transit-modal .input-radio label:before,
                .form-control:focus,
                .create-notice-modal .btn-back,
                .module-notices ._item:hover,
                .mat-input-element:focus,
                .display-orientation .btn,
                .switch.active .switch__control,
                .display-orientation .btn,
                .amenity-tiles-item.selected,
                .multiselect-item-checkbox input[type=checkbox]+ div:before,
                .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle,
                .active-border-container.active,
                .view-type.active,
                .agreement-types .active
                {
                    border-color: ${this.obj.colors.primary} !important;
                }

                /* hover border-color primary  */
                .btn-primary:hover,
                .btn-default-green:hover,
                .detailed-view-body .btn-default:hover,
                .btn-in-table .btn:hover,
                .parcel-modal .parcel-type-switch:hover,
                .radio-tabs:hover,
                .pure-checkbox input[type="checkbox"] + label:hover:before,
                .parcel-transit-modal .input-radio label:hover:before
                {
                    border-color: ${this.obj.colors.primaryHover} !important;
                }

                .item-nav__link.item-nav__link_active,.active_menu
                {
                    border-left: 4px solid ${this.obj.colors.primary} !important;
                }
                .img-checkbox .svg-checked, .icon,
                .img-checkbox .svg-halfchecked,
                .nav > li.active .nav-bar-mini-icon {
                    fill: ${this.obj.colors.primary} !important;
                }

                /* switch shadow */
                .switch.active .switch__control
                {
                    box-shadow: ${this.obj.colors.primary} 0 0 0 16px inset !important;
                }

                /* logo  */
                #navigation-menu .logo, .loginscreen .logo { background-image: url(${this.obj.logo}) !important; }
                body.mini-navbar #navigation-menu .logo { background-image: url(${this.obj.miniLogo}) !important; }
                /* menu border  */

                .ct-series-a .ct-point,
                .ct-series-a .ct-line,
                .ct-series-a .ct-bar,
                .ct-series-a .ct-slice-donut,
                .ct-series-b  .ct-slice-donut {
                    stroke: ${this.obj.colors.primary};
                }

                .sidebarMenu .navbar-default,
                .sidebarMenu .nav li,
                .sidebarMenu .nav li mat-expansion-panel-header,
                .sidebarMenu .nav li ul,
                .sidebarMenu .nav li ul li,
                .login-container {
                    background: ${this.obj.colors.menuBackgroundColor} !important;
                }

                .sidebarMenu .nav li a,
                .sidebarMenu .nav li mat-panel-title,
                .settings-nav-header,
                .username-wrapper .username,
                .username-wrapper .fa-user-circle,
                .login-container {
                    color: ${this.obj.colors.menuFontColor} !important;
                }

                .nav-image-svg {
                    background-color: ${this.obj.colors.menuFontColor} !important;
                }


                .username-wrapper .img-placeholder {
                    background-color: ${this.obj.colors.menuFontColor} !important;
                }

                .sidebarMenu .nav li a .icon-plus-minus:before,
                .sidebarMenu .nav li a .icon-plus-minus:after,
                .nav > li mat-divider{
                    border-color: ${this.obj.colors.menuFontColor} !important;
                }

                .sidebarMenu .nav li a.active-group,
                .sidebarMenu .nav li.active-group a .nav-label,
                .sidebarMenu .nav li mat-panel-title.active-group .nav-label,
                .sidebarMenu .nav li.active-group a i,
                .sidebarMenu .nav li.active-link a,
                .sidebarMenu .nav li.active_menu .nav-label{
                    color: ${this.obj.colors.selectedMenuItemFontColor} !important;
                }

                .active-group .nav-image-svg {
                    background-color: ${this.obj.colors.selectedMenuItemFontColor} !important;
                }
            </style>
        `).appendTo('head');

        this.onThemeChanged.emit(this.obj);
    }

    saveColor(name: string, value: string) {
        this.obj.colors[name] = value;
        this.saveState();
        this.updateStyle();
    }

    saveLogo(src: string) {
        this.obj.logo = src;
        this.saveState();
        this.updateStyle();
    }

    saveState() {
        const objJson = JSON.stringify(this.obj);
        localStorage.setItem('mtvCustomStyle', objJson);
    }

    enableTheme(theme: Theme) {
        theme = new Theme(
            +theme.id,
            theme.name,
            theme.logo,
            theme.settings,
            theme.companies,
            theme.createdAt);
        this.obj = {
            id: theme.id,
            colors: theme.colors,
            logo: theme.logo || this.defaultLogo,
            miniLogo: theme.miniLogo ? theme.miniLogo : theme.logo || this.defaultLogo,
        };
        this.saveState();
        this.updateStyle();
    }

    public getCurrentThemeId() {
        return this.obj.id;
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/custom-style.service.ts